import http from  './axios'
export const delPatient = param =>{return http.post("clinic-manager/patient/delHisPatient",param).then(res=>res.data.data)};
//删除医院患者
export const patientDetail = param =>{return http.post("clinic-manager/patient/getHisPatientById",param).then(res=>res.data.data)};
//根据id查询医院患者详情
export const patientList = param =>{return http.post("clinic-manager/patient/getHisPatientList",param).then(res=>res.data.data)};
//患者列表
export const savePatient = param =>{return http.post("clinic-manager/patient/saveHisPatient",param).then(res=>res.data.data)};
//保存医院患者
export const updPatient = param =>{return http.post("clinic-manager/patient/updHisPatient",param).then(res=>res.data.data)};
//修改医院患者

// export const getEmployeePage = param =>{return http.post("partner-sale/ludan/page",param).then(res=>res.data.data)};
//查询新冠员工信息
export const getEmployeePage = param =>{return http.post("clinic-manager/covid/page",param).then(res=>res.data.data)};
//根据id查询合作伙伴订单详情新
export const getDetail = param => { return http.post("partner-manager/order/getDetail",param).then(res=>res.data)}

export const qrCodeBase64 = param => { return http.post("clinic-manager/covid/qrCodeBase64",param).then(res=>res.data)}
export const delNCP = param => { return http.post("partner-sale/NCP/del",param).then(res=>res.data)}
export const xgOrder = param => { return http.post("clinic-manager/covid/xgOrder",param).then(res=>res.data)}



// WEBPACK FOOTER //
// ./src/api/patient.js